import axios from 'axios';

export default {
  FETCH_TPLAYLISTS ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('playlists/getAllCuratedPlaylistsWithVideos')
        .then((response) => {
          const { data: { data : { payload } } } = response;
          localStorage.setItem('playlists', JSON.stringify(payload));
          commit('SET_PTLAYLIST', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FILTER_TPLAYLISTS ({commit, dispatch}, filterText){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/playlists/searchAlikeTitleVideos/${filterText}`)
        .then((response) => {
          const { data: { data : { payload } } } = response;
          commit('SET_FILTER_RESULTS', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GETSELECTEDTPLAYLIST ({ commit }, playlistId) {
    commit('TOGGLE_LOADING', true);
    return axios.get(`playlists/getAllCuratedPlaylistsWithVideos`).then((response) => {
      commit('TOGGLE_LOADING', false);
      const { data: { data : { payload }} } = response;

      console.log('payload', payload)
      let selectedTPlaylist = payload.filter(x => {
        return x.playlistId.toString() === playlistId.toString()
      });

      console.log('found playlist', selectedTPlaylist)
      commit('SET_SELECTED_TPLAYLIST', selectedTPlaylist[0])
    }, (err) => {
      commit('TOGGLE_LOADING', false);
      console.log('err ', err)
    })
  },
  ADD_TPLAYLIST({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      console.log("add playlist payload : ", payload);
      axios.post('playlists/insertCuratedPlaylistWithVideos', payload)
        .then((response) => {
          console.log('ADD_PLAYLIST action fetch response : ', response);
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('ADD_PLAYLIST action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  SYNC_ARCHIVE_EVENT({commit, dispatch}, eventId){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/events/getEventVideos/${eventId}`)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          if (data && data.length > 0) {
            resolve(data);
          } else {
            reject('dsfads');
          }
        })
        .catch((error) => {
          console.log('UPDATE_PLAYLIST action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  // UPDATE_VIDEO_META_DATA({commit, dispatch}, csvVideoCodes){
  //   // https://adminapi1.dev-tonenetworks.com/v1/events/getEventVideos/{eventId}
  //   console.log('new meta data paylaod', csvVideoCodes )
  //   return new Promise((resolve, reject) => {
  //     commit('TOGGLE_LOADING', true);
  //     axios.post('/corporations/updateToneDBWithJWData', {csvVideoCodes: csvVideoCodes} )
  //       .then((response) => {
  //         const { data: { data } } = response;
  //         commit('TOGGLE_LOADING', false);
  //         resolve(data);
  //       })
  //       .catch((error) => {
  //         console.log('UPDATE_PLAYLIST action fetch error : ', error);
  //         reject(error);
  //         commit('TOGGLE_LOADING', false);
  //       });
  //   })
  // },
    REMOVE_VIDEO_META_DATA({commit, dispatch}, csvVideoCodes){
    console.log('new meta data paylaod', csvVideoCodes )
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/playlists/deleteToneVideos/${csvVideoCodes}`)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_PLAYLIST action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_TPLAYLIST({commit, dispatch}, payload){
    console.log('updaet payload', payload)
    console.log('playload id', payload.playlistId)
    let updatePayload = {
      'playlistId': payload.playlistId,
      'playlistTitle': payload.playlistTitle,
      'playlistDescription': payload.playlistDescription,
      'csvVideoCodes': payload.csvVideoCodes,
      'active': payload.active
    }
    console.log('new paylaod', updatePayload)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/playlists/updateCuratedPlaylistWithVideos', updatePayload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_PLAYLIST action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/trendingPlaylists/actions.js